import React from "react";
import { Card } from "@lightspeed/flame/Card";
import { ReactComponent as LocationIcon } from "../../assets/location.svg";

const formatLastDate = (value) => {
  if (!value) return "N/A";
  const raw = String(value);
  const date = new Date(raw.replace(" ", "T"));
  if (Number.isNaN(date.getTime())) return raw.slice(0, 16);
  return `${date.toISOString().slice(0, 10)} (${String(date.getHours()).padStart(2, "0")})`;
};

const CustomerLocationStrip = ({
  locations,
  selectedCompanyId,
  selectedAreaId,
  loading,
  syncing,
  error,
  onAreaChange,
  onSync,
}) => {
  return (
    <>
      {onSync && (
        <div style={syncBarStyle}>
          <button
            type="button"
            onClick={onSync}
            disabled={loading || syncing || !selectedCompanyId}
            style={syncButtonStyle(loading || syncing || !selectedCompanyId)}
          >
            {syncing ? "SYNCING..." : "SYNC"}
          </button>
        </div>
      )}

      {error && <div style={locationErrorStyle}>{error}</div>}

      <div className="location-bar">
        {loading ? (
          <div style={emptyLocationStyle}>Loading locations...</div>
        ) : locations.length ? (
          locations.map((location) => {
            const active = String(location.area_id) === String(selectedAreaId);

            return (
              <Card
                key={location.area_id}
                top="true"
                className={`location-button ${active ? "inverted" : ""}`}
                style={{ border: active ? "2px solid #0078d4" : "1px solid #dcdcdc" }}
                onClick={() => onAreaChange(location.area_id)}
              >
                <div>
                  <LocationIcon style={{ width: 16, height: 16, marginBottom: 4 }} />
                  <br />
                  {location.area_name || location.area_id}
                </div>

                <div title={`Last transaction date: ${location.last_date || ""}`} style={lastDateStyle}>
                  {formatLastDate(location.last_date)}
                </div>
              </Card>
            );
          })
        ) : (
          <div style={emptyLocationStyle}>No locations</div>
        )}
      </div>
    </>
  );
};

const syncBarStyle = {
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "center",
  padding: "8px 16px 0",
};

const syncButtonStyle = (disabled) => ({
  backgroundColor: disabled ? "#86c79a" : "#28a745",
  color: "#fff",
  border: "none",
  borderRadius: 4,
  padding: "7px 14px",
  fontWeight: 700,
  fontSize: 13,
  cursor: disabled ? "default" : "pointer",
  opacity: disabled ? 0.7 : 1,
  minWidth: 70,
  height: 34,
});

const locationErrorStyle = {
  color: "#b91c1c",
  fontSize: 13,
  fontWeight: 600,
  padding: "6px 16px",
};

const emptyLocationStyle = {
  padding: "16px 0",
  color: "#64748b",
  fontSize: 13,
};

const lastDateStyle = {
  fontSize: 12,
  color: "red",
  fontWeight: "bold",
  marginTop: 4,
};

export default CustomerLocationStrip;
